import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { TrackedAsyncData } from 'ember-async-data';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import add from 'ember-math-helpers/helpers/add';
import { on } from '@ember/modifier';
import pick from '../../helpers/pick';
import set from 'ember-set-helper/helpers/set';
import Breadcrumbs from '../breadcrumbs';
import VisualizeSessionTypeGraph from './visualize-session-type-graph';

export default class CourseVisualizeSessionTypeComponent extends Component {
  @service iliosConfig;
  @service intl;
  @tracked title;

  paths = [
    {
      route: 'course',
      title: this.args.model.course.title,
    },
    {
      route: 'course-visualizations',
      title: this.intl.t('general.visualizations'),
    },
    {
      route: 'course-visualize-session-types',
      title: this.intl.t('general.sessionTypes'),
    },
  ];

  @cached
  get academicYearCrossesCalendarYearBoundariesData() {
    return new TrackedAsyncData(
      this.iliosConfig.itemFromConfig('academicYearCrossesCalendarYearBoundaries'),
    );
  }

  get academicYearCrossesCalendarYearBoundaries() {
    return this.academicYearCrossesCalendarYearBoundariesData.isResolved
      ? this.academicYearCrossesCalendarYearBoundariesData.value
      : false;
  }
  <template>
    <section
      class="course-visualize-session-type data-visualization"
      data-test-course-visualize-session-type
    >
      {{#if this.academicYearCrossesCalendarYearBoundariesData.isResolved}}
        <Breadcrumbs
          @paths={{this.paths}}
          @model={{@model.course}}
          @rootTitle={{@model.sessionType.title}}
        />
        <h2>
          {{t "general.vocabularyTermsFor" subject=@model.sessionType.title}}
        </h2>
        <h3 class="clickable" data-test-title>
          <LinkTo @route="course" @model={{@model.course}}>
            {{@model.course.title}}
            {{#if this.academicYearCrossesCalendarYearBoundaries}}
              {{@model.course.year}}
              -
              {{add @model.course.year 1}}
            {{else}}
              {{@model.course.year}}
            {{/if}}
          </LinkTo>
        </h3>
        <div class="filter" data-test-filter>
          <input
            aria-label={{t "general.filterChartPlaceholder"}}
            autocomplete="off"
            type="search"
            value={{this.title}}
            placeholder={{t "general.filterPlaceholder"}}
            {{on "input" (pick "target.value" (set this "title"))}}
          />
        </div>
        <div class="visualizations">
          <VisualizeSessionTypeGraph
            @filter={{this.title}}
            @course={{@model.course}}
            @sessionType={{@model.sessionType}}
            @showDataTable={{true}}
          />
        </div>
      {{/if}}
    </section>
  </template>
}
